import { AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { GridService } from 'app/services/grid.service';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../services/config.service';
import { DrakeUserComponent } from '../drake-user/drake-user.component';
import { DrakeFilePreviewComponent } from '../drake-file-preview/drake-file-preview.component';

@Component({
    selector: 'app-drake-social-view',
    templateUrl: './drake-social-view.component.html',
    styleUrls: ['./drake-social-view.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        InputsModule,
        DropDownsModule,
        UploadModule,
        DateInputsModule,
        FormsModule,
        MatIconModule,
        DrakeUserComponent,
        DrakeFilePreviewComponent
    ]
})
export class DrakeSocialViewComponent implements AfterViewInit, OnChanges {

    @Input() public scope: string = '';
    @Input() public viewCode: string = '';
    @Input() public filter: string = '{}';
    @Input() public sort: string = '{}';
    @Input() public commandName: string = 'READ';
    @Input() public userIdField: string = '';
    @Input() public messageField: string = '';
    @Input() public mediaField: string = '';
    @Input() public dateField: string = '';

    public data: Array<any> = [];
    public gridData: any[] = [];
    public gridView: any[];
    public gridColumns: any[] = [];
    public items: any[];

    constructor(
        private gridService: GridService,
        private drakeSharedService: DrakeSharedService,
        private http: HttpClient,
        private configService: ConfigService
    ) {

    }

    ngAfterViewInit(): void { }

    loadGridConfiguration(): void {
        if (!this.viewCode || !this.scope || !this.commandName) {
            return; // Ensure that all necessary data is available before proceeding
        }

        // Carica la configurazione della griglia
        this.gridService.getScopeView(this.viewCode).subscribe(
            (viewConfig: any) => {

                this.gridColumns = viewConfig.fields.map((field: any) => {
                    const columnConfig = {
                        field: field.columnName,
                        title: field.header,
                        width: field.size,
                        hidden: !field.visible,
                        filter: field.filter,
                        sortable: field.sort,
                        format: field.format ? `{0:${field.format}}` : undefined,
                        cssClass: field.cssClass,
                        template: field.template,
                        fieldType: field.fieldType,
                        fieldControlType: field.fieldControlType,
                        fieldControlFormat: field.fieldControlFormat,
                        order: field.order,
                        group: field.group
                    };
                    //console.log('Column Config:', columnConfig);
                    return columnConfig;
                });
                this.loadGridData();
            },
            (error) => {
                console.error('Errore durante il caricamento della configurazione della griglia', error);
            }
        );
    }

    loadGridData(): void {
        this.gridView = [];
        const requestData = {
            ViewCode: this.viewCode,
            Filter: this.filter,
            Sort: this.sort,
            Page: 0,
            PageSize: 0,
            Language: "",
            Cache: false,
            ExtraData: {}
        };
        console.log('requestData: ', requestData);
        this.gridService.getScopeData(this.scope, this.commandName, requestData).subscribe(
            (response: any) => {
                this.gridData = response.data.map((item: any) => {
                    for (let key in item) {
                        if (item[key] === null || item[key] === undefined) {
                            item[key] = '';
                        }
                    }
                    return item;
                });
                this.gridView = [...this.gridData];
                this.items = this.gridView;
            },
            (error) => {
                console.error('Error loading grid data', error);
                console.error('Request Data:', requestData);
            }
        );
    }

    ngOnChanges(changes) {
        //console.log(changes);
        if ((changes.scope && changes.scope.currentValue != '') || (changes.viewCode && changes.viewCode.currentValue != ''))
            this.loadGridConfiguration();
    }

    onSelectionChange(event: any) {
  
    }
    
}
